<template>
  <div class="login" style="font-size: 14px">
    <div
      v-show="!showForget"
      id="loginPopup"
      class="openBox"
      data-href="https://oralenglish.fifedu.com/kyxl-web/teacher/index.do"
      style="
        height: auto !important;
        display: block;
        margin-top: -152.5px !important;
      "
    >
      <div class="openTitle flex-bet">
        <p>一体化智慧教学综合平台</p>
        <a title="关闭" class="close" v-on:click="close"></a>
      </div>
      <form>
        <div class="openCon">
          <div class="login-div">
            <form method="get">
              <div class="user-div">
                <p 
                  v-if="userName.length == 0"
                  style="
                    top: 2px;
                    font-size: 16px;
                    line-height: 48px;
                    padding-left: 60px;
                  "
                  ref="userMess"
                  id="userMess"
                >
                  请输入学号 / 工号 / 身份证号
                </p>
                <input
                  name="user"
                  type="text"
                  maxlength="50"
                  id="username"
                  ref="userinp"
                  v-model.trim="userName"
                  @focus="userFocus"
                  @blur="userBlur"
                  @change="userChange"
                />
                <em ref="userIcon" id="userIcon"></em>
              </div>
              <div class="password-div">
                <p
                  v-if="passWord.length == 0"
                  style="
                    top: 2px;
                    font-size: 16px;
                    line-height: 48px;
                    padding-left: 60px;
                  "
                  ref="passMess"
                  id="passMess"
                >
                  请输入密码
                </p>
                <input
                  v-if="changePass"
                  name="password"
                  type="password"
                  maxlength="30"
                  id="password"
                  ref="passinp"
                  v-model.trim="passWord"
                  @focus="passFocus"
                  @blur="passBlur"
                />
                <input
                  v-else
                  name="password"
                  type="text"
                  maxlength="30"
                  id="password"
                  ref="passinp"
                  v-model.trim="passWord"
                  @focus="passFocus"
                  @blur="passBlur"
                />
                <em ref="passIcon" id="passIcon"></em>
              </div>
              <div class="code-div clearfix">
                <p id="capMess">请输入验证码</p>
                <input
                  name="x_code"
                  type="text"
                  maxlength="4"
                  id="captcha"
                  ref="captcha"
                  v-model.trim="capValue"
                  @focus="capFocus"
                  @blur="capBlur"
                />
                <div class="code_pic">
                  <img
                    id="code_pic"
                    src
                    alt
                    title="点击刷新"
                    @click="getCaptcha()"
                  />
                </div>
                <div
                  title="点击刷新"
                  class="code_btn"
                  @click="getCaptcha()"
                ></div>
              </div>
              <div class="remember-wrap clearfix" v-show="errorText">
                <div
                  class="errorval"
                  ref="errorval"
                  style="display: block"
                  v-html="errorText"
                ></div>
              </div>
              <div class="passview-div clearfix">
                <input
                  type="checkbox"
                  name="passview"
                  id="passview"
                  @click="showPass"
                />
                <label for="passview">设置密码可见</label>
                <a @click="toRetrieve">忘记密码?</a>
              </div>
              <input
                id="loginBtn"
                type="button"
                value="登录"
                class="btn_submit"
                @click="subMit"
              />
            </form>
          </div>
        </div>
      </form>
    </div>
    <!-- 找回密码 -->
    <div
      v-if="showForget"
      id="forgetPassPopup"
      class="openBox openBox-login"
      style="
        width: 453px;
        height: auto;
        display: block;
        margin-top: -155px !important;
        margin-left: -227px;
      "
    >
      <div class="openTitle">
        <p>找回密码 - 手机号码验证</p>
        <a title="关闭" class="close" v-on:click="close"></a>
      </div>
      <div class="openCon">
        <div class="login-div">
          <div class="tel-div">
            <p
              ref="telInp"
              style="
                top: -20px;
                font-size: 14px;
                line-height: 48px;
                padding-left: 0px;
              "
            >
              请输入学校简称+学号
            </p>
            <input
              ref="telPoint"
              type="text"
              maxlength="11"
              v-model.trim="forGetadd"
              @focus="telFocus"
              @blur="telBlur"
            />
          </div>
          <div class="tel-div">
            <p
              ref="telInp"
              style="
                top: 2px;
                font-size: 14px;
                line-height: 48px;
                padding-left: 30px;
              "
            >
              请输入手机号
            </p>
            <input
              ref="telPoint"
              type="text"
              maxlength="11"
              v-model.trim="telNumber"
              @focus="telFocus"
              @blur="telBlur"
            />
          </div>
          <div class="code-div telcode-div clearfix">
            <p ref="telcodeInp">请输入验证码</p>
            <input
              ref="telCodePoint"
              type="text"
              maxlength="6"
              v-model.trim="telCodeNumber"
              @focus="codeFocus"
              @blur="telcodeBlur"
            />
            <a
              class="tel_code_btn"
              ref="sendCodeT"
              @click="sendCode"
              v-html="sendCodeText"
            ></a>
          </div>
          <div
            class="errorval"
            ref="telErrorval"
            style="display: none"
            v-html="errorMessage"
          ></div>
          <input
            id="loginBtn"
            type="button"
            value="下一步"
            class="btn_submit"
            @click="nextStep"
          />
        </div>
      </div>
    </div>
    <div
      v-if="showReset"
      class="openBox openBox-login"
      id="forgetPassPopup2"
      style="
        display: block;
        width: 455px;
        margin-top: -155px;
        margin-left: -227px;
      "
    >
      <div class="openTitle">
        <p>找回密码 - 新密码设置</p>
        <a class="close" title="关闭" v-on:click="close"></a>
      </div>
      <div class="openCon">
        <div class="login-div">
          <p class="tip_orange">
            <!-- 您要找回密码的用户名为：{{ roleName.loginName }} -->
          </p>
          <div class="tel-div">
            <p ref="newPassT">请输入您的新密码</p>
            <input
              ref="newPassInp"
              name="pass1"
              type="password"
              maxlength="20"
              id="pass1"
              v-model.trim="newPassword"
              @focus="newPassFocus"
              @blur="newPassBlur"
            />
          </div>
          <div class="tel-div">
            <p ref="newPassAT">请再次输入新密码</p>
            <input
              ref="newPassAInp"
              name="pass2"
              type="password"
              maxlength="20"
              id="pass2"
              v-model.trim="newPasswordAgain"
              @focus="newPassAFocus"
              @blur="newPassABlur"
            />
          </div>
          <p class="tip_orange" style="padding-bottom: 0">
            为保护您的账号安全，请输入字母、数字或英文符号至少两种组合的密码
          </p>
          <div
            class="errorval"
            v-html="newPassErr"
            ref="newPassErr"
            style="display: none"
          ></div>
          <input
            class="btn_submit"
            id="loginBtn"
            type="button"
            value="确定"
            @click="findPassFunc"
          />
        </div>
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="changePwd.dialogVisible"
      :before-close="handleClose"
      close-on-press-escape
      width="35%"
    >
      <p class="dialog-title">用户名</p>
      <el-input
        readonly
        v-model="changePwd.loginName"
        placeholder="用户名"
      ></el-input>
      <p class="dialog-title">旧密码</p>
      <el-input
        v-model="changePwd.pwd"
        placeholder="旧密码"
        type="password"
      ></el-input>
      <p class="dialog-title">新密码</p>
      <el-input
        v-model="changePwd.newPwd"
        type="password"
        placeholder="新密码"
      ></el-input>
      <p class="dialog-title">请确认新密码</p>
      <el-input
        v-model="changePwd.newPwd1"
        placeholder="请确认新密码"
        type="password"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePwd.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePwdConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios"; // 引入axios
import CryptoJS from "crypto-js";
import { Process } from "../request/host";
import {
  getUserName,
  verifiCation,
  checkUserName,
  checkCaptcha,
  getValidateCode,
  checkVerification,
  resetPassWord,
  changePwds,
} from "../request/api";
import { EduSSO } from "../../static/utils/sso";
// import { showLoading, hideLoading } from '../../static/utils/loading';

export default {
  data() {
    return {
      thisPage: "",
      userInfo: "",
      userName: "",
      passWord: "",
      username: "",
      capValue: "",
      telNumber: "",
      forGetadd: "",
      telCodeNumber: "",
      loginError: false,
      isLogin: false, //默认未登录
      domain: "", //获取二级域名
      subDomain: true,
      errorText: null,
      checkUser: false,
      openAppList: [],
      tempId: 1, //模板id
      nextpage: "",
      cmsStatus: 0,
      uuid: "", //验证码
      footImg: "",
      subdomainsrc: "",
      appCode: "",
      isAllowData: {},
      alertIkowAllow: false,
      isSetAllow: false,
      userInfo: "",
      changePass: true, // 设置密码可见
      showForget: false, // 关闭忘记密码框
      errorMessage: "", // 找回密码-错误信息
      sendCodeText: "发送验证码",
      showReset: false, // 重设密码框
      newPassword: "", // 输入新密码
      newPasswordAgain: "", // 再次输入新密码
      newPassErr: "", // 新密码错误弹窗
      startCount: true, // 判断是否禁用 获取验证码
      roleName: {
        roleName: "",
        realName: "",
        pic: "",
        logo: "",
        title: "",
        templateId: this.tempId,
        roleList: [],
        openAppList: this.openAppList,
        userId: "",
        loginName: "",
        nextpage: this.nextpage,
      },
      //修改密码
      changePwd: {
        dialogVisible: false,
        loginName: "",
        pwd: "",
        newPwd: "",
        newPwd1: "",
      },
    };
  },
  created() {
    if (this.getHostPath() !== "http:") {
      this.domain = this.getHostPath().split("//")[1].split(".")[0]; //获取二级域名
    }
    this.thisPage = sessionStorage.getItem("tempId");
    // 打开登录框
    this.openLogin();
  },
  mounted() {},
  computed: {
    reSubdomain: () => {
      if (
        this.domain == "www" ||
        this.domain == "test" ||
        this.domain == "test2" ||
        this.domain == "localhost:8080"
      ) {
        this.subDomain = false;
        return false;
      }
    },
  },
  methods: {
    handleClose(done) {
      this.$confirm("取消修改密码？")
        .then((_) => {
          document.querySelector(".v-modal").remove();
          done();
        })
        .catch((_) => {});
    },
    //修改密码
    changePwdConfirm() {
      let changePwd = this.changePwd;
      console.log(changePwd);
      if (changePwd.pwd === "")
        return this.$message({
          showClose: true,
          message: "请填写旧密码",
          type: "error",
        });
      if (changePwd.newPwd === "")
        return this.$message({
          showClose: true,
          message: "请填写新密码",
          type: "error",
        });
      if (changePwd.newPwd1 === "")
        return this.$message({
          showClose: true,
          message: "请填写新密码",
          type: "error",
        });
      if (changePwd.newPwd1 !== changePwd.newPwd)
        return this.$message({
          showClose: true,
          message: "新密码不一致请重新填写",
          type: "error",
        });
      if (
        !/(?!^(\d+|[a-zA-Z]+|[~!@#$%^*]+)$)^[\w~!@#$%^*]{8,20}$/.test(
          changePwd.newPwd
        )
      )
        return this.$message({
          showClose: true,
          message:
            "密码应为8-20位以内的英文字母、数字或特殊字符~!@#$%^*中的至少两种组合",
          type: "error",
        });
      if (
        !/(?!^(\d+|[a-zA-Z]+|[~!@#$%^*]+)$)^[\w~!@#$%^*]{8,20}$/.test(
          changePwd.newPwd1
        )
      )
        return this.$message({
          showClose: true,
          message:
            "密码应为8-20位以内的英文字母、数字或特殊字符~!@#$%^*中的至少两种组合",
          type: "error",
        });
      var Base64 = require("js-base64").Base64;
      const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
      const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
      const srcs1 = CryptoJS.enc.Utf8.parse(changePwd.pwd);
      let encrypted1 = CryptoJS.AES.encrypt(srcs1, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const srcs2 = CryptoJS.enc.Utf8.parse(changePwd.newPwd);
      let encrypted2 = CryptoJS.AES.encrypt(srcs2, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      changePwds({
        loginName: changePwd.loginName,
        pwd: Base64.encode(encrypted1),
        newPwd: Base64.encode(encrypted2),
      }).then((res) => {
        if (res.status === "SUCCESS") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.changePwd.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },

    // 设置密码可见
    showPass() {
      if (this.changePass) {
        this.changePass = false;
      } else {
        this.changePass = true;
      }
    },
    // 找回密码
    toRetrieve() {
      this.showForget = true;
      this.telCodeNumber = "";
      this.newPassword = "";
    },
    // 获取手机号焦点
    telFocus() {
      this.$refs.telInp.style =
        "top: -20px;font-size: 12px;line-height: 22px;padding-left: 0;";
      this.$refs.telPoint.style = "border:1px #3D6FEA solid;color:#4A4A4A";
    },
    // 获取验证码焦点
    codeFocus() {
      this.$refs.telcodeInp.style =
        "top: -20px;font-size: 12px;line-height: 22px;padding-left: 0;";
      this.$refs.telCodePoint.style = "border:1px #3D6FEA solid;color:#4A4A4A";
    },
    // 失去手机号焦点
    telBlur() {
      if (this.telNumber == "") {
        this.$refs.telErrorval.style = "display: block;";
        this.$refs.telInp.style =
          "top: 2px;font-size: 14px;line-height: 48px;padding-left: 30px;";
        this.errorMessage = "请输入手机号";
      } else {
        this.$refs.telErrorval.style = "display:none";
      }
      this.$refs.telPoint.style = "border: #E2E2E2 solid 1px #9B9B9B";
    },
    // 失去验证码焦点
    telcodeBlur() {
      if (this.telCodeNumber == "") {
        this.$refs.telcodeInp.style =
          "top: 2px;font-size: 14px;line-height: 48px;padding-left: 30px;";
      }
      this.$refs.telCodePoint.style = "border: #E2E2E2 solid 1px #9B9B9B";
    },
    sendCode() {
      const m = this;
      if (this.startCount) {
        this.$refs.telErrorval.style = "display: block;";
        if (this.telNumber == "") {
          this.errorMessage = "请输入手机号";
          this.$refs.telErrorval.style = "display:block";
        } else if (!/^1[3456789]\d{9}$/.test(this.telNumber)) {
          this.errorMessage = "手机号格式有误";
          this.$refs.telErrorval.style = "display:block";
        } else {
          this.$refs.telErrorval.style = "display: none;";
          getValidateCode({
            mobile: m.telNumber,
            loginName: m.forGetadd,
            type: "2",
          })
            .then((res) => {
              if (res.status == "SUCCESS") {
                m.roleName.loginName = res.data.loginName;
                m.$message({
                  message: "验证码已发送到您的手机！",
                  type: "success",
                });
                let time = "120";
                m.$refs.sendCodeT.style =
                  "background-color: #9B9B9B;cursor: default;";
                m.sendCodeText = time + "s后可重发";
                m.startCount = false;
                var timer = setInterval(function () {
                  if (time > 1) {
                    time--;
                    m.sendCodeText = time + "s后可重发";
                  } else {
                    clearInterval(timer);
                    m.$refs.sendCodeT.style =
                      "background-color: #3D6FEA;cursor: pointer;";
                    m.sendCodeText = "发送验证码";
                    m.startCount = true;
                  }
                }, 1000);
              } else if (res.status == "ERROR") {
                this.$alert(res.message, "手机号", {
                  confirmButtonText: "确定",
                });
              }
            })
            .catch((res) => {
              m.$message({
                message: res.status,
                type: "warning",
              });
            });
        }
      }
    },
    // 获取到验证码，提交》
    nextStep() {
      if (
        this.telCodeNumber != "" &&
        this.telNumber != "" &&
        /^1[3456789]\d{9}$/.test(this.telNumber)
      ) {
        this.$refs.telErrorval.style = "display: none";
        const m = this;
        checkVerification({
          mobile: m.telNumber,
          validCode: m.telCodeNumber,
          loginName: m.forGetadd,
        })
          .then((res) => {
            if (res.status == "SUCCESS") {
              m.$message({
                message: "验证成功",
                type: "success",
              });
              // m.roleName.loginName = res.data.loginName;
              m.showForget = false;
              m.showReset = true;
            } else {
              this.$alert("验证码输入有误", "验证码", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$message({
                    type: "info",
                    message: "请输入正确验证码",
                  });
                },
              });
            }
          })
          .catch((res) => {
            m.$message({
              message: res.message,
              type: "warning",
            });
          });
      } else {
        this.$refs.telErrorval.style = "display: block";
        if (this.telNumber == "") {
          this.errorMessage = "请输入手机号";
        } else if (this.telCodeNumber == "") {
          this.errorMessage = "请输入验证码";
        } else if (
          this.telNumber != "" &&
          !/^1[3456789]\d{9}$/.test(this.telNumber)
        ) {
          this.errorMessage = "手机号格式有误";
        }
      }
    },
    findPassFunc() {
      const m = this;
      this.$refs.newPassErr.style = "display: block";
      if (this.newPassword == "") {
        this.newPassErr = "请输入您的新密码";
      } else if (
        !/(?!^(\d+|[a-zA-Z]+|[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·]+)$)^[\w`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·]{8,20}$/.test(
          this.newPassword
        )
      ) {
        this.newPassErr =
          "密码应为8-20位以内的字母、数字或英文字符至少两种组合";
        $("#forgetPassPopup2 #pass1").focus();
      } else if (this.newPasswordAgain == "") {
        this.newPassErr = "请再次输入新密码";
        $("#forgetPassPopup2 #pass2").focus();
      } else if (this.newPassword != this.newPasswordAgain) {
        this.newPassErr = "两次输入的新密码不一致";
        $("#forgetPassPopup2 #pass2").focus();
      } else {
        this.$refs.newPassErr.style = "display: none";
        resetPassWord({
          mobile: m.telNumber,
          validCode: m.telCodeNumber,
          newPass: m.newPassword,
          loginName: m.forGetadd,
        })
          .then((res) => {
            if (res.status == "SUCCESS") {
              m.$message({
                message: "密码修改成功",
                type: "success",
              });
              m.close();
            }
          })
          .catch((res) => {
            m.$message({
              message: res.message,
              type: "warning",
            });
          });
      }
    },
    newPassFocus() {
      this.$refs.newPassT.style =
        "top: -20px;font-size: 12px;line-height: 22px;padding-left: 0;";
      this.$refs.newPassInp.style = "border:1px #3D6FEA solid;color:#4A4A4A";
    },
    newPassAFocus() {
      this.$refs.newPassAT.style =
        "top: -20px;font-size: 12px;line-height: 22px;padding-left: 0;";
      this.$refs.newPassAInp.style = "border:1px #3D6FEA solid;color:#4A4A4A";
    },
    newPassBlur() {
      if (this.newPassword == "") {
        this.$refs.newPassT.style =
          "top: 2px;font-size: 14px;line-height: 48px;padding-left: 30px;";
      } else {
        this.$refs.newPassErr.style = "display:none";
      }
      this.$refs.newPassInp.style = "border: #E2E2E2 solid 1px #9B9B9B";
    },
    newPassABlur() {
      if (this.newPasswordAgain == "") {
        this.$refs.newPassAT.style =
          "top: 2px;font-size: 14px;line-height: 48px;padding-left: 30px;";
      } else {
        this.$refs.newPassErr.style = "display:none";
      }
      this.$refs.newPassAInp.style = "border: #E2E2E2 solid 1px #9B9B9B";
    },
    // 打开登录框
    openLogin() {
      let code = "";
      if (this.isLogin == true || this.isIndex == 1) {
        for (var i = 0; i < this.openAppList.length; i++) {
          if (code == this.openAppList[i].code) {
            if (this.openAppList[i].buy == false) {
              $("#openBox-noBuy").show();
            } else if (
              (this.openAppList[i].buy == true) &
              (this.openAppList[i].auth == false)
            ) {
              $("#openBox-noAuth").show();
            } else if (
              this.openAppList[i].buy == true &&
              this.openAppList[i].auth == true
            ) {
              window.open(this.openAppList[i].link);
            }
          }
        }
      } else {
        if (code) {
          this.appCode = code;
        } else {
          this.appCode = null;
        }
        this.offLoginWindow();
      }
    },
    close() {
      this.showForget = false;
      this.showReset = false;
      this.$emit("offLogin", false);
    },
    // 关闭用户协议声明
    closeAllow() {
      $(".openBox-allow").hide();
      this.alertIkow(
        "<p>我们仅会将您的信息用于提供服务或改善服务体验，我们将保护您的信息安全。同时根据《中华人民共和国网络安全法》的要求，获取您的信息前必须获得您的同意。请您知悉。</p><p><b>如您不同意，将无法使用我们的服务。</b></p>",
        "",
        "noclose"
      );
      this.alertIkowAllow == true;
    },
    // 同意协议并登陆
    savaAllow() {
      //保存签署协议
      var m = this;
      var saveData = m.initData(
        m.getIplatPath() + "/valid/getUserNameSignin",
        "post",
        "username=" + m.userName
      ); //同意签署协议
      if (saveData.status == "SUCCESS") {
        $("#openBox-allow").hide();
        m.isSetAllow = true;
        m.checkAppClick();
      }
    },
    alertIkow(text, src, noclose, title, submitTitle) {
      var randomID = this.ran(13);
      var titleText = title ? title : "提示";
      var submitTitleText = submitTitle ? submitTitle : "我知道了";
      var str1 =
        '<div class="openbgIkow"></div><div class="openBox openBox_Ikow" id="openBox_Ikow' +
        randomID +
        '" style="display:none">\
      <div class="openTitle"><p>' +
        titleText +
        '</p></div>\
      <div class="openCon"><div class="scrollDiv">' +
        text +
        '</div></div>\
      <div class="openBtn"><input type="button" class="inputbtn" value="我知道了"></div></div>';
      var str2 =
        '<div class="openbgIkow"></div><div class="openBox openBox_Ikow" id="openBox_Ikow' +
        randomID +
        '" style="display:none">\
      <div class="openTitle"><p>' +
        titleText +
        '</p><a class="close" title="关闭" onClick="$(this).parent().parent().remove();$(\'.openbgIkow\').remove();"></a></div>\
      <div class="openCon"><div class="scrollDiv">' +
        text +
        '</div></div>\
      <div class="openBtn"><input type="button" class="inputbtn" value="' +
        submitTitleText +
        '"></div></div>';
      var str = noclose && noclose == "noclose" ? str1 : str2;
      $("body").append(str);
      var alertOBJ = $("#openBox_Ikow" + randomID);
      alertOBJ
        .find(".scrollDiv")
        .css({ overflow: "auto", "max-height": $(window).height() - 170 });
      alertOBJ.css({ "margin-top": -alertOBJ.height() / 2 }).fadeIn();
      alertOBJ.find(".inputbtn").click(function () {
        if ($("#openBox-allow").length > 0 && this.alertIkowAllow == true) {
          $("#openBox-allow").show();
          this.alertIkowAllow = false;
        }
        if (src && src != "") {
          top.location.href = src;
        } else {
          $(this).parent().parent().remove();
          $(".openbgIkow").remove();
        }
      });
    },
    // 点击登录
    subMit() {
      this.loginFunc();
    },
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      // http://bfsu.meixuego.com
      return localhostPath;
    },
    //获取base路径
    getBasePath() {
      return this.getHostPath() + "/iplat/bp"; //线上接口
    },
    //获取iplat路径
    getIplatPath() {
      return this.getHostPath() + "/iplat"; //线上接口
    },
    //获取iplat路径 线上下
    getIplatCasPath() {
      // 线上
      var login = `${Process.env.VUE_APP_CYCORE}/cas-server`;
      // 测试
      // var login = "https://test.fifedu.com/cas-server";
      return login;
    },
    // 时间随机数-最大13位
    ran(m) {
      m = m > 13 ? 13 : m;
      var num = new Date().getTime();
      return num.toString().substring(13 - m);
    },
    initUserUrl: function () {
      var local = window.document.location.href;
      var localName = local.split("?")[0].split("/")[
        local.split("?")[0].split("/").length - 2
      ]; //所在文件夹名
      var hrefName = local
        .split("?")[0]
        .split("/")
        [local.split("?")[0].split("/").length - 2].split(".")[0]; //文件名
      if (
        (this.thisPage == undefined && localName != this.roleName.roleName) ||
        (this.cmsStatus == 0 && this.thisPage == 3)
      ) {
        // top.location.href = this.thisPage != undefined ? '/dist/index.html':'../index.html';
      }
      if (this.roleName.roleName == "collegeadmin" && hrefName == "msg") {
        top.location.href = "index.html";
      }
    },
    // 获取验证码
    getCaptcha: function () {
      const m = this;
      $(".code_pic").addClass("loading");
      $.ajax({
        url:
          `${Process.env.VUE_APP_CYCORE}/fif_captcha/getCaptcha?t_=` +
          Date.parse(new Date()),
        success: function (data) {
          $(".code_pic").removeClass("loading");
          document.getElementById("code_pic").src = JSON.parse(data).data.image;
          m.uuid = JSON.parse(data).data.uuid;
        },
      });
    },
    // 验证账号密码匹配否
    verifiCation() {
      verifiCation({ username: this.userName, password: this.passWord })
        .then((res) => {
          if (res.status == "SUCCESS") {
            // console.log('账号密码匹配')
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    initUser: function () {
      var m = this;
      m.roleName.roleName = "";
      if (m.roleName.roleName == "") {
        var userInfoSrc = this.getBasePathCMS("m") + "/common/getUserName";
        var mydata;
        var local = window.document.location.href;
        var hrefName = local
          .split("?")[0]
          .split("/")
          [local.split("?")[0].split("/").length - 1].split(".")[0];
        $.ajax({
          url: userInfoSrc,
          type: "post",
          async: false, //同步
          data: "",
          dataType: "json",
          timeout: 5000,
          success: function (data) {
            if (data.status == "SUCCESS") {
              let cmsStatus = data.data.status;
              m.cmsStatus = cmsStatus;
            } else if (data.status == "401") {
              // 先退出登录
              var logouturl = `${Process.env.VUE_APP_CYCORE}/cas-server/logout`;
              sessionStorage.removeItem("isIndex");
              sessionStorage.removeItem("tempId");
              sessionStorage.removeItem("user");
              sessionStorage.removeItem("islogin");
              $.ajax({
                url: logouturl,
                type: "get",
                async: false, //同步
                dataType: 'jsonp',
                timeout: 5000,
                success: (result) => {
                  location.href = data.data;
                },
              });
              return;
            }
            // 二级域名下||设置了status=1的学校账户：获取模板id(刚开通二级域名但还未在首页管理中选择模板id时)
            if (m.subDomain == true || m.cmsStatus == 1) {
              //获取模板id
              var templateUrl = m.getBasePathCMS() + "/front/getPageIndex"; //模板id
              $.ajax({
                url: templateUrl,
                type: "post",
                async: false, //同步
                dataType: "json",
                timeout: 60000,
                success: function (data) {
                  if (data.status == "SUCCESS") {
                    m.roleName.templateId = data.data.pageIndex.templateId;
                    m.tempId = m.roleName.templateId;
                    m.cmsStatus = data.data.status;
                    m.thisPage = data.data.pageIndex.templateId;
                  } else {
                    if (m.subDomain == true) {
                      m.$message(data.message, Process.env.VUE_APP_CYCORE);
                    }
                  }
                },
                error: function (e1, e2, e3) {
                  m.$message("网络开小差了，请稍后再试！");
                },
              });
            }
            //二级域名下-获取头部信息
            if (m.subDomain == true && m.cmsStatus == 1) {
              var contentUrl = m.getBasePathCMS() + "/front/contentList"; //内容列表
              var baseInfo = m.initData(contentUrl, "post", "categoryId=1").data
                .contentList; //查基础信息类内容
              if (baseInfo.length > 0) {
                m.roleName.logo = baseInfo[0].picPath;
                m.roleName.title = baseInfo[0].shortName;
                $("head title").text(baseInfo[0].shortName);
                m.footImg = baseInfo[0].resizePath;
              } else {
                m.roleName.logo =
                  m.isindex != undefined
                    ? "../assets/img/login/logo_fif.png"
                    : "../assets/img/login/logo_fif.png";
                m.roleName.title = "智慧教学平台";
                $("head title").text("智慧教学平台");
              }
            }
            if (hrefName == "index") {
              m.openAppList = m.initData(
                m.getBasePath() + "/common/getAllApplication",
                "post"
              ).data;
              if (data.data.member != undefined) {
                var name = data.data.member.loginName;
                name = name.toLowerCase();
                for (var i = 0; i < m.openAppList.length; i++) {
                  if (
                    "icet" == m.openAppList[i].code &&
                    m.openAppList[i].link != undefined
                  ) {
                    m.openAppList[i].link +=
                      "&u=" + name + "&p=" + sessionStorage.getItem(name);
                  }
                  if (
                    "akt" == m.openAppList[i].code &&
                    m.openAppList[i].link != undefined
                  ) {
                    var aktData = m.initData(
                      m.getBasePath() + "/member/akthref",
                      "post"
                    ).data;
                    m.openAppList[i].link = aktData.hrefurl;
                    $("#mainIndex").attr("src", aktData.url);
                    m.initData(aktData.url, "get");
                  }
                }
              }
              m.roleName.openAppList = openAppList;
            }
            if (data.status != "SUCCESS") {
              if (hrefName != "index") {
                //除无需登录的页面（模板2下的新闻页）跳回首页
                if (
                  hrefName == "notice-list" ||
                  hrefName == "notice-detail" ||
                  hrefName == "news-list" ||
                  hrefName == "news-detail"
                ) {
                  if (m.tempId == 1) {
                    top.location.href =
                      this.thisPage != undefined
                        ? "/dist/index.html"
                        : "../index.html";
                  }
                } else {
                  top.location.href =
                    m.thisPage != undefined
                      ? "/dist/index.html"
                      : "../index.html";
                }
              }
            } else {
              m.userInfo = data;
              m.username = data.data.member.loginName;
              if (m.thisPage == 1 || m.thisPage == 3) {
                // 需登录的页面-判断该用户是否签署协议
                m.isAllowData = m.initData(
                  m.getIplatPath() + "/valid/allow",
                  "post",
                  "username=" + data.data.member.loginName,
                  "pop"
                ).data; //读取线上是否签署协议
                if (m.isAllowData.status == null || m.isAllowData.status == 1) {
                  //未签署
                  $("#openBox-allow").show();
                  return;
                }
                m.checkAppClick();
              }
              m.setUserName();
            }
          },
          error: function (e1, e2, e3) {
            if (hrefName != "index") {
              top.location.href = this.thisPage = "/iplat/dist/index.html";
            }
          },
        });
      }
    },
    setUserName: function () {
      //用户信息
      var m = this;
      m.roleName.roleName = m.userInfo.data.member.roleName;
      m.roleName.userId = m.userInfo.data.member.id;
      m.roleName.realName = m.userInfo.data.member.name;
      m.roleName.loginName = m.userInfo.data.member.loginName;
      m.roleName.pic = m.getIplatPath() + m.userInfo.data.member.avatar;
      m.username = m.userInfo.data.member.loginName;
      m.initUserUrl();
      m.isLogin = true;
      m.subdomainsrc = m.userInfo.data.subdomain;
      //教师、负责人切换角色
      if (
        m.roleName.roleName == "teacher" ||
        m.roleName.roleName == "tcadmin"
      ) {
        var openData = m.initData(
          m.getBasePath() + "/member/getRoleList",
          "post"
        );
        sessionStorage.setItem("isIndex", 1);
        if (openData.status == "SUCCESS") {
          m.roleName.roleList = openData.data;
        }
      }
      location.href = m.getIplatPath() + "/dist/index.html";
    },
    // 获取user焦点
    userFocus() {
      // 边框颜色获焦
      $("#username").css({ border: "#3D6FEA solid 1px", color: "#4a4a4a" });
      // 提示信息
      $("#userMess").css({
        top: "-20px",
        "font-size": "12px",
        "line-height": "22px",
        "padding-left": "0",
      });
      $("#userIcon").css({
        background:
          "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAmtJREFUOBGVVE9rE1EQn3mbmIMecuh6E2zQevELeEhSEdQWFS8VL8lHMH+wSlF0q1IPBrb9BPUfKHorgl6UGhG/gBdFG69mq0ZBwaR548wuL9ndbAi+8Jh5M7+Z7Pzem0FIWESER+vfT/RJlxHgEENyPoygRQAfAOHhsezUc8dBHQ9nfHQV6u150LBGBAeinpHTZwSsN9fsjbBnkNBxSL36+W2ZNF0BoIE9DB7VkZSCxt4jU0tPz2Ff/MqAgmT6ajyZQrxpqcxB2aIbfCAJtabF9rvt28buf4mUSX18Fk8GCm+8ce3rBiwyX/OWQdO1sA0ApaSzUr6SCxDORpJxRAbS96KByTaJ5Z8rtKnZmndy3AV0LeBLja4km48gyL3sbM8pTViOhgxP2OuVhqdAS7IZDJddSiHCDH9h4uJH5uSrHqWt1H0B9Po7ZU3gJILFSDCDhar3g3nMjgX9hwMRO4NnMyHuD/tlT1yScCuOYi7+sm1dIcxbGWtfc9XeI1t0QDzF9rssu/E4LrmF+Yr3iIs/b5yc7D2kd51pNrItY0uShYudaeh1N5j+w0M/PlYKySfcGFVKLUxKJljBCNbE+ZKHhtp07Rd805+Mg3b0caNPkhEswpZMIG5PJO7oirSPJNCIbrHSvjApmWAEG+CkUbAm44wpC1ax2l7hN7Zkzkz6JuuN8NzzJ9Iv7iyNi0A0a7DM253Xrn1JzoOEC0/I+vrWu0WAl8N9zXT8ZtuXAEz7uQl2i26WJAuPr0FCAyjWvNOaaJWfQM7YEiVzJmWOHbDhIClNGp3/rSTtxHVM+35+Z6x/ZLIfhKkIx/4DBTP06o4EaR0AAAAASUVORK5CYII=') no-repeat",
      });
      $("#passMess").css({
        top: "-20px",
        "font-size": "12px",
        "line-height": "22px",
        "padding-left": "0",
      });
      $("#passIcon").css({
        background:
          "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAXxJREFUOBFjZIACz0n/2b/de5v0j+F/PCMDgzrD//9/gVI3/zMyztfUFFk4K53xN0wtMTTQDAYGh7K3Mv9+/Vv///9/E2yaGBkZLnBzcrptb+d9jU0emxgTyKX4DAVp+v+fweDLt+97HBr+s2AzBJsYo33Bm8x///9NwyaJLsbExJjOyC8yD10cG5/RtuD1CaCTzGGSQG/vZGLlSvj7+zsjUBxkiAdMjhSaCRxRSDrYGNmyDnTzvDg8QfQ5KxNTCpIUSUwmklSToJjlPzBJAdXDg+LX/1/THEq/gIPi979/c0gwC0UpCxMD40Jg2oUbDEwB7n9/fXuOogrKwRZ5fz+8+QmMC7DPGRkY/zIJinCAlDOCktvXe2+O4ErDSBZcYhYUNT7QwPgHSYwBGPl/kQ0+NFEUnCSZtucx/mRiYwpkZGQ8g6wBmQ3KIDxcnC7ohiKrQWeDvXCgS/gJt5KIDRMjUxYDI+NJoCUfgKnlLRAfA/JTNTRFzUjJdSBLAK2ehybV5/gYAAAAAElFTkSuQmCC') no-repeat",
      });
      // this.passFocus();
    },
    // 失去user焦点
    userBlur() {
      if ($("#username").val() == "") {
        this.errorText = null;
        // 提示信息
        $("#userMess").css({
          top: "2px",
          "font-size": "16px",
          "line-height": "48px",
          "padding-left": "60px",
        });
      }
      // 边框颜色还原
      $("#username").css({ border: "#E2E2E2 solid 1px" });
      $("#userIcon").css({
        background:
          "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAmRJREFUOBGdlD+IE0EUxrObgBcuhWgtSDBJIwSEVCJaqfmLTUAId5WNjXI2IojG007hPLQQG/9wjaTLHxQESZ/CRgIXvYuFpeBZaFBI1t+37OhmXLzDgce8973vfTvzdmacWMTwPM8pl8tnHMdZJp3D0qKBj8E2cTcKhcLLZrM5Ex4eTjiQX6lUShSuY0fsnBVvIX6l1+u1w3jcBHzNTaVSq7PZ7BHYQYP/Yz5A7nwul1vM5/NvhsOhJ+5vwUDsOtjcqlnF7UQiccF13Qes+iv5kyoMhgN2fDqdJkej0WthfrG2ycq6Jg7IMcRW2dJNE2umt7cQuRHG8D2457R9l6S+sg44t7Kg4JlVqDAKU+2a2ubWarWzCEb+ALbp9yUsGoUpj0Z6MBgUXbaqoxE5yC3ZiSjMcBBdShBkDWDPEJr0jMl7rhx9WhZm80JxVgf4C6T9IfC/XT644+6lGuJ32V64EtyOIP4AexKPx0sLCwuHut1uSiYf4Qr2FPtp17HTsXo4wo6ZJMR3/Mlap9MZhzDjfsKR9arVqm5VG5GjJkntJrWu33ADEtfDYga3Z3HEtfANt91uv0L5g0lwjU4bf7c5zEVjWy+Qi6Nrc5li/xDjr5VKpUu7iYkjbsBT7YqeM/9x4GK/z2Qy+wBPYLpGxWw2ewr73Gg0tvr9vv+x4EUqwn0M52LAjbH1e9zjh8R/7m+9Xo9PJpM7NPpqGMf/xko+Mut6HWZalG8GYneTyeS1Vqs1FabVzA1eniqF97H0XMIK+IiO24r9wP51sDlvHZqboaBCwQvsLf6OTL4w5cSxxcjFfgEZRvrBt58XCAAAAABJRU5ErkJggg==') no-repeat",
      });
      if ($("#password").val() == "") {
        this.passBlur();
      }
    },
    // user change事件
    userChange() {
      if ($("#password").val() == "") {
        this.passBlur();
      } else {
        $("#passMess").css({
          top: "-20px",
          "font-size": "12px",
          "line-height": "22px",
          "padding-left": "0",
        });
        $("#passIcon").css({
          background:
            "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAXxJREFUOBFjZIACz0n/2b/de5v0j+F/PCMDgzrD//9/gVI3/zMyztfUFFk4K53xN0wtMTTQDAYGh7K3Mv9+/Vv///9/E2yaGBkZLnBzcrptb+d9jU0emxgTyKX4DAVp+v+fweDLt+97HBr+s2AzBJsYo33Bm8x///9NwyaJLsbExJjOyC8yD10cG5/RtuD1CaCTzGGSQG/vZGLlSvj7+zsjUBxkiAdMjhSaCRxRSDrYGNmyDnTzvDg8QfQ5KxNTCpIUSUwmklSToJjlPzBJAdXDg+LX/1/THEq/gIPi979/c0gwC0UpCxMD40Jg2oUbDEwB7n9/fXuOogrKwRZ5fz+8+QmMC7DPGRkY/zIJinCAlDOCktvXe2+O4ErDSBZcYhYUNT7QwPgHSYwBGPl/kQ0+NFEUnCSZtucx/mRiYwpkZGQ8g6wBmQ3KIDxcnC7ohiKrQWeDvXCgS/gJt5KIDRMjUxYDI+NJoCUfgKnlLRAfA/JTNTRFzUjJdSBLAK2ehybV5/gYAAAAAElFTkSuQmCC') no-repeat",
        });
      }
    },
    // 获取pass焦点
    passFocus() {
      // 边框颜色获焦
      $("#password").css({ border: "#3D6FEA solid 1px", color: "#4a4a4a" });
      $("#passMess").css({
        top: "-20px",
        "font-size": "12px",
        "line-height": "22px",
        "padding-left": "0",
      });
      $("#passIcon").css({
        background:
          "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAXxJREFUOBFjZIACz0n/2b/de5v0j+F/PCMDgzrD//9/gVI3/zMyztfUFFk4K53xN0wtMTTQDAYGh7K3Mv9+/Vv///9/E2yaGBkZLnBzcrptb+d9jU0emxgTyKX4DAVp+v+fweDLt+97HBr+s2AzBJsYo33Bm8x///9NwyaJLsbExJjOyC8yD10cG5/RtuD1CaCTzGGSQG/vZGLlSvj7+zsjUBxkiAdMjhSaCRxRSDrYGNmyDnTzvDg8QfQ5KxNTCpIUSUwmklSToJjlPzBJAdXDg+LX/1/THEq/gIPi979/c0gwC0UpCxMD40Jg2oUbDEwB7n9/fXuOogrKwRZ5fz+8+QmMC7DPGRkY/zIJinCAlDOCktvXe2+O4ErDSBZcYhYUNT7QwPgHSYwBGPl/kQ0+NFEUnCSZtucx/mRiYwpkZGQ8g6wBmQ3KIDxcnC7ohiKrQWeDvXCgS/gJt5KIDRMjUxYDI+NJoCUfgKnlLRAfA/JTNTRFzUjJdSBLAK2ehybV5/gYAAAAAElFTkSuQmCC') no-repeat",
      });
    },
    // 失去pass焦点
    passBlur() {
      // 边框颜色还原
      $("#password").css({ border: "#E2E2E2 solid 1px" });
      if ($("#password").val() == "") {
        $("#passMess").css({
          top: "2px",
          "font-size": "16px",
          "line-height": "48px",
          "padding-left": "60px",
        });
        $("#passIcon").css({
          background:
            "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAAWNJREFUOBGVU71Kw1AUzk0EQ/MEoW4ZXAVNXBxFJcliX0ARRSzkHfIOhQ5BKp0LdUpAcBRR6lDcOqRTQUEEl0CClvidYsIlXCS58HHP75dz7jlh0t/xPG99Pp+fQT0BNoElMJNl+UbX9WEQBN/Qax9GkZ1OZyNN01uIO6JMxti01WodjEajD5FfZJOp0v9IKSnP860kSe59318TkYhszHGcKyT2Rc6qDZVfmqY5qNpFOhE/gXi3cCL5Dvqpqqosy7IB5KPC1+Sm1mhQ/OlGUfROBtd1z0G84J11ZbluYNM4qngGlE8BuW/bdvEU100Ji3giHgIlMVo/hP6GTSliyls0vMlkkiFn1Tn8SwxXpQRG6xbH8QNk4Q6XrJL0alnWNlbuh7NJGP6SJw7DkIqV5F6vl2EDjiG/8Am8jEqmmqbtV0n5mKq8amE8Hi8Mw9gDQRd4Br6AT+BRUZSLdrttNfnr6CO/qZJ8riV17ZYAAAAASUVORK5CYII=') no-repeat",
        });
      }
    },
    // 验证码焦点
    capFocus() {
      // 边框颜色获焦
      $("#captcha").css({ border: "#3D6FEA solid 1px", color: "#4a4a4a" });
      $("#capMess").css({
        top: "-20px",
        "font-size": "12px",
        "line-height": "22px",
        "padding-left": "0",
      });
    },
    // 失去验证码焦点
    capBlur() {
      // 边框颜色还原
      $("#captcha").css({ border: "#E2E2E2 solid 1px" });
      if ($("#captcha").val() == "") {
        $("#capMess").css({
          top: "2px",
          "font-size": "16px",
          "line-height": "48px",
          "padding-left": "30px",
        });
      }
    },
    // 关闭/登录登录窗口
    offLoginWindow() {
      const that = this;
      document.onkeydown = function (event) {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 27) {
          that.close();
          // 按 Esc
        } else if (e && e.keyCode == 13) {
          // 回车 登录
          if (this.showForget) {
            that.loginFunc();
          } else {
            // 手机号验证码获取
          }
        }
        return true;
      };
    },

    // 登录
    loginFunc() {
      if (
        this.subDomain == true &&
        this.userName.substr(0, this.domain.length).toLowerCase() !=
          this.domain &&
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          this.userName
        )
      ) {
        this.userName = this.userName;
      }
      let Base64 = require("js-base64").Base64;
      if (window.sessionStorage && this.userName != "" && this.passWord != "") {
        sessionStorage.setItem("user", this.userName);
        sessionStorage.setItem(
          this.userName.toLowerCase(),
          Base64.encode(this.passWord)
        ); // 设置值 qlf
      }
      if (this.userName == null || this.userName == "") {
        // 账号
        this.errorText =
          "请输入" +
          (this.subDomain == true ? "学号 / 工号" : "用户名") +
          " / 身份证号";
        $("#loginPopup .user-div input").focus();
        return false;
      } else if (this.passWord == null || this.passWord == "") {
        // 密码
        this.errorText = "请输入密码";
        $("#loginPopup .password-div input").focus();
        return false;
      }
      // 判断验证码
      if ($("#loginPopup .code-div input").is(":visible")) {
        var captcha = document.getElementById("captcha").value;
        if (captcha == null || captcha == "") {
          this.errorText = "请输入验证码";
          $("#loginPopup .code-div input").focus();
          return false;
        }
        checkCaptcha({ uuid: this.uuid, captcha: captcha }).then((res) => {
          if (res.data.check != "successed") {
            // console.log('账号密码匹配')
            this.errorText = res.data.msg;
            $("#loginPopup .code-div input").focus();
            this.getCaptcha();
            return false;
          } else {
            this.checkPass();
          }
        });
      } else {
        this.checkPass();
      }
    },

    // 验证账号
    checkPass() {
      let isCheck = true;
      if (
        this.subDomain == true &&
        this.userName.substr(0, this.domain.length).toLowerCase() !=
          this.domain &&
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          this.userName
        )
      ) {
        this.userName = this.userName;
      }

      if (isCheck) {
        var that = this;
        let Base64 = require("js-base64").Base64;
        const keyCryptoJs = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
        const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
        const srcs = CryptoJS.enc.Utf8.parse(this.passWord);
        let encrypted = CryptoJS.AES.encrypt(srcs, keyCryptoJs, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        // verifiCation({
        //   username: this.userName,
        //   password: Base64.encode(encrypted),
        // }).then((res) => {
        //   var laterTime = 0;
        //   if (res.status != "SUCCESS") {
        //     this.changePwd = {
        //       dialogVisible: res.data == "3" ? true : false,
        //       loginName: this.userName,
        //       pwd: "",
        //       newPwd: "",
        //       newPwd1: "",
        //     };
        //     //that.close()
        //     that.$message(res.message);
        //     //不知道哪里来的遮罩层，强制去掉
        //     setTimeout(() => {
        //       document.querySelector(".v-modal").remove();
        //     }, 1000);
        //     laterTime = 2000;
        //   } else {
          
        //   }
        // });
        setTimeout(() => {
              // 登录
              let userName = that.userName.toLowerCase().indexOf(this.getHostHeadr()) != -1?that.userName:this.getHostHeadr() + that.userName
              var wwwUrl = "https://www.fifedu.com/iplat/ssoservice?nextPage=";
              var loginurl = wwwUrl + that.getIplatPath() + "/ssoservice";
              var edusso = new EduSSO(loginurl, that.getIplatCasPath());
              edusso.login(
                "iflyportal",
                "iflyportal",
                "login_name",
                userName,
                that.passWord,
                that.uuid,
                (result) => {
                  // console.log(result);
                  if (result && result.result != "success") {
                    if (result.data == "请输入验证码") {
                      that.getCaptcha(); //获取/刷新验证码
                      $("#loginPopup .code-div").show();
                    }
                    that.errorText = result.data;
                    $("#loginPopup .password-div input").focus();
                  } else {
                    // showLoading();
                    // console.log(result, "else");
                    that.close();
                    that.initUser(); //火狐登陆会马上刷新 不进入该函数，而谷歌登陆不刷新 先进入该函数 然后刷新 导致应用弹窗提示不一致
                    // 禁用tab、enter
                    document.onkeydown = function (e) {
                      e = e || window.event;
                      key = e.keyCode || e.which;
                      if (key == 9 || key == 13) {
                        return false;
                      }
                    };
                  }
                }
              );
            }, 1000);
      }

      if (this.appCode != null) {
        if (window.sessionStorage) {
          sessionStorage.setItem("appCode", this.appCode); // 设置值
        } else if (window.localStorage) {
          localStorage.setItem("appCode", this.appCode);
        } else {
          // 不支持 sessionStorage/localStorage
        }
      }
    },
    getHostHeadr(){
         let header = location.host;
         let result = header.split('.fifedu.com')[0]
         return result
    },
    checkAppClick: function () {
      // 判断登录前是否点击过app
      var m = this;
      //判断是否点击app登录
      /* var getAppCode = sessionStorage.getItem("appCode"); // 取值
      if (getAppCode != null) {
        sessionStorage.removeItem("appCode"); // 删除 */
      for (var i = 0; i < this.openAppList.length; i++) {
        if (this.openAppList[i].code == getAppCode) {
          if (this.openAppList[i].buy == false) {
            $("#openBox-noBuy").show();
            return false;
          } else if (
            this.openAppList[i].buy == true &&
            this.openAppList[i].auth == false
          ) {
            $("#openBox-noAuth").show();
            return false;
          } else {
            top.location.href = this.openAppList[i].link;
            return false;
          }
        }
      }
      if (m.isSetAllow) {
        m.setUserName();
      }
    },
    //获取url中的参数对象
    getRequest(_url) {
      var url = _url ? String(_url) : String(document.location); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        if (str.indexOf("#") != -1) {
          str = str.substr(0, str.indexOf("#"));
        }
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          var indexOfadd = strs[i].indexOf("=");
          if (indexOfadd > 0) {
            var key = strs[i].substr(0, indexOfadd);
            var value = strs[i].substr(indexOfadd + 1);
            theRequest[key] =
              (key in theRequest ? theRequest[key] + "," : "") + value;
          }
        }
      }
      return theRequest;
    },
    //获取base路径-CMS
    getBasePathCMS(m) {
      if (m != undefined) {
        return this.getHostPath() + "/iplat/cms"; //线上接口
      } else if (this.subDomain == false && this.thisPage == 1) {
        return "www"; //首页静态接口
      } else {
        return this.getHostPath() + "/iplat/cms"; //线上接口
      }
    },
    // 接口调用函数
    initData(url, datatype, dataval, opentype) {
      var mydata;
      if (opentype == "pop") {
        $(".loading")
          .css({ "background-color": "rgba(255,255,255,.6)" })
          .show();
      } else {
        $(".loading").css({ "background-color": "rgba(255,255,255,1)" }).show();
      }
      $.ajax({
        url: url,
        type: datatype,
        async: false, //同步
        data: dataval ? dataval : "",
        dataType: "json",
        timeout: 60000,
        success: function (data) {
          $(".loading").hide();
          if (data.status != "SUCCESS") {
            mydata = false;
            return;
          } else {
            mydata = data;
          }
        },
        error: function (e1, e2, e3) {
          $(".loading").hide();
          this.$message("网络开小差了，请稍后再试！");
        },
      });
      return mydata;
    },
  },
};
</script>

<style lang="less">
.el-message__icon {
  font-size: 25px;
}
.tip_orange {
  color: #fb7e2a;
  padding-bottom: 25px;
}
.clearfix {
  zoom: 1;
  clear: both;
}
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
}
.passview-div {
  margin-top: 20px;
  position: relative;
  margin-bottom: 20px;
  color: #4a4a4a;
  input {
    float: left;
    width: auto;
    height: auto;
    margin: 3px;
  }
  label {
    float: left;
    cursor: default;
  }
  a {
    float: right;
    cursor: pointer;
    margin-right: 10px;
  }
}
.login-div > div {
  position: relative;
  margin-bottom: 20px;
}
.el-message-box {
  vertical-align: baseline !important;
  .el-button--primary {
    background: #3d6fea !important;
    border-color: #3d6fea !important;
    border-radius: 0 !important;
  }
}
/*登陆弹窗*/
#loginPopup {
  width: 453px;
  border-radius: 2px;
  background-color: #fff;
  margin-left: -227px;
  label {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
}
.openTitle {
  height: 40px;
}
.openTitle a.close {
  float: right;
  background: url("../assets/img/login/close.png") no-repeat;
  width: 12px;
  height: 13px;
  margin-top: 12px;
  cursor: pointer;
}
.openTitle {
  padding: 0 11px 0 38px;
}
.openTitle p {
  font-size: 20px;
  font-weight: normal;
  line-height: 28px;
  color: #1746ae;
  padding-top: 25px;
  float: left;
}
.login-div {
  padding: 35px 18px 10px;
}
.code-div {
  height: 50px;
}
.user-div,
.password-div,
.code-div {
  position: relative;
  margin-bottom: 20px;
}
.login-div em {
  position: absolute;
  width: 20px;
  height: 20px;
  display: block;
  top: 15px;
  left: 18px;
}
.user-div em {
  background: url("../assets/img/login/login_user.png") no-repeat;
}
.password-div em {
  background: url("../assets/img/login/login_pass.png") no-repeat;
  top: 18px;
}
.user-div :focus input,
.password-div :focus input,
.code-div :focus input {
  border: #3d6fea solid 1px;
  color: #4a4a4a;
}
.user-div p,
.password-div p,
.code-div p {
  font-size: 16px;
  letter-spacing: 0;
  color: #9b9b9b;
  background-color: #fff;
  line-height: 48px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  padding-left: 60px;
  transition: all 150ms ease;
}
.user-div p.top,
.password-div p.top,
.code-div p.top {
  font-size: 12px;
  line-height: 22px;
  top: -20px;
  padding-left: 0;
}
.user-div input,
.password-div input,
.code-div input {
  margin: 0;
  padding: 0;
  outline: none;
  border: #e2e2e2 solid 1px;
  height: 48px;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 48px;
  padding: 0 20px 0 60px;
  width: 288px;
  display: block;
  border-radius: 2px;
  background-color: transparent;
}
.code-div {
  display: none;
}
.code-div input {
  float: left;
  width: 95px;
  padding: 0 30px;
}
.code-div p {
  padding-left: 30px;
}
.code-div .code_pic {
  float: left;
  margin-top: 5px;
  margin-left: 30px;
  width: 100px;
  height: 40px;
  background-color: #f4f4f4;
}
.code-div .code_btn {
  float: left;
  width: 21px;
  height: 21px;
  background: url("../assets/img/login/icon-fresh.png") no-repeat;
  margin-top: 14px;
  margin-left: 20px;
  cursor: pointer;
}
.password-div input {
  font-size: 28px;
  letter-spacing: 5px;
}
#password {
  font-size: 18px;
}
.remember-wrap {
  margin: -5px 0 10px;
}
.errorval {
  color: #d0021b;
  font-size: 12px;
}
.remember-div {
  position: relative;
  display: inline;
}
.remember-div input {
  position: absolute;
  top: 1px;
  left: 1px;
  z-index: 1;
}
.btn_submit {
  background: #3d6fea;
  color: #fff;
  border: none;
  padding: 0;
  width: 100%;
  line-height: 40px;
  font-size: 18px;
  cursor: pointer;
  margin: 30px 0 15px 0;
}
.btn_submit:hover {
  background-color: #fb7e2a;
}
#loginPopup .btn_submit {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
}
.login-div > div input {
  margin: 0;
  padding: 0;
  outline: none;
  border: #e2e2e2 solid 1px;
  height: 48px;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 48px;
  padding: 20px 0 60px;
  width: 295px;
  display: block;
  border-radius: 2px;
  background-color: transparent;
}
.login-div > div.focus input {
  border: #3d6fea solid 1px;
  color: #4a4a4a;
}
.login-div > div p {
  font-size: 14px;
  letter-spacing: 0;
  color: #9b9b9b;
  background-color: #fff;
  line-height: 48px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  padding-left: 60px;
}
.login-div > div p.top {
  font-size: 12px;
  line-height: 22px;
  top: -20px;
  padding-left: 0;
}
.code-div {
  display: none;
}
.login-div > div.code-div input {
  float: left;
  width: 95px;
  padding: 0 30px;
}
.login-div > div.code-div p {
  padding-left: 30px;
}
/* 找回密码 */
.login-div > div.tel-div input {
  padding: 0 30px;
  width: 313px;
}
.login-div > div.tel-div p {
  padding-left: 30px;
}
.telcode-div {
  display: block;
}
.login-div > div.telcode-div input {
  width: 163px;
}
.telcode-div .tel_code_btn {
  float: left;
  width: 150px;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
  background-color: #3d6fea;
  color: #fff;
  cursor: pointer;
}
.telcode-div .tel_code_btn:hover {
  background-color: #fb7e2a;
  text-decoration: none;
}
.telcode-div .tel_code_btn.disabled,
.telcode-div .tel_code_btn.disabled:hover {
  background-color: #9b9b9b;
  cursor: default;
}
.dialog-title {
  margin-top: 10px;
}

// 媒体查询
@media screen and (max-width: 768px) {
  #loginPopup {
    width: auto;
    top: 45%;
    margin-left: 0;
    transform: translate(-50%, 0);
  }
  .user-div input,
  .password-div input,
  .code-div input {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue